var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedometer-04",
    clipPath: "url(#clip0_5087_24067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.8299 10.6653C12.3571 9.90945 12.6663 8.99018 12.6663 7.9987C12.6663 7.65544 12.6293 7.32083 12.5589 6.99867M4.16947 10.6654C3.64222 9.90948 3.33301 8.9902 3.33301 7.9987C3.33301 5.42137 5.42235 3.33203 7.99967 3.33203C8.2811 3.33203 8.5567 3.35694 8.8244 3.40468M10.9996 4.9987L7.99961 7.9987M14.6663 7.9987C14.6663 11.6806 11.6816 14.6654 7.99967 14.6654C4.31778 14.6654 1.33301 11.6806 1.33301 7.9987C1.33301 4.3168 4.31778 1.33203 7.99967 1.33203C11.6816 1.33203 14.6663 4.3168 14.6663 7.9987ZM8.66634 7.9987C8.66634 8.36689 8.36786 8.66536 7.99967 8.66536C7.63148 8.66536 7.33301 8.36689 7.33301 7.9987C7.33301 7.63051 7.63148 7.33203 7.99967 7.33203C8.36786 7.33203 8.66634 7.63051 8.66634 7.9987Z",
    stroke: "#6D49D4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5087_24067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.487cafe739140b98336b643010e1e2b5.svg";
export { ForwardRef as ReactComponent };